import CampaignPerformanceCard from './CampaignPerformanceCard'
import LeadsManagementCard from './LeadsManagementCard'

export default function DashboardBottomSection({
  campaignPerformance,
  leadsManagement,
  period,
  customRange,
}) {
  return (
    <section className="grid items-stretch gap-4 xl:grid-cols-[2fr_3fr]">
      <CampaignPerformanceCard
        data={campaignPerformance}
        period={period}
        customRange={customRange}
      />
      <LeadsManagementCard
        data={leadsManagement}
        period={period}
        customRange={customRange}
      />
    </section>
  )
}
